<template>
  <div class="page_title">
    <span>
    {{title}}<slot name="left"></slot>
    </span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:""
    }
  }
}
</script>

<style lang="scss" scoped>
.page_title{
  font-size: 16px;
  font-weight: 600;
  height: 40px;
  padding:20px 30px 17px 30px;
  line-height: 40px;
  border-bottom:1px solid rgba(230,227,227,1);
  display: flex;
  justify-content: space-between;
}
</style>
